// Development environment configuration
export const environment = {
  production: false,
  envName: 'development',
 apiUrl: 'https://bsfms-devapi.bsecured.in/api',
  // apiUrl: 'http://localhost:3000/api',

  // Feature flags for development
  enableDebugTools: true,
  logLevel: 'debug',

  // UI <-> API payload encryption (shared/security). Harmless where the API has it
  // off: the key endpoint returns 503 and requests go out plain.
  payloadEncryption: true
};
